import { ROLE_SCOPES } from '../../constants'

export enum ACTIONS {
  ALERTS_ASSIGNMENT = 'alerts:assignment',
  ALERTS_RESOLUTION = 'alerts:resolution',
  ALERTS_MUTE = 'alerts:mute',
  RULE_SET_CREATE = 'ruleSet:create',
  GLOBAL_SEARCH = 'global_search',
  ATTRIBUTE_SET_UPDATE = 'attribute_set:update',
  ATTRIBUTE_SET_CREATE = 'attribute_set:create',
  NOTIFICATIONS_CREATE = 'notifications:create',

  REPORT_CREATE = 'report:create',
  ROPA_PROCESS_CREATE = 'ropa_process:create',
  ROPA_PROCESS_CLONE = 'ropa_process:clone',
  ROPA_PROCESS_DELETE = 'ropa_process:delete',
  ROPA_PROCESS_UPDATE = 'ropa_process:update',
  ROPA_TEMPLATE_CREATE = 'ropa_template:create',
  ROPA_TEMPLATE_CLONE = 'ropa_template:clone',
  ROPA_TEMPLATE_UPDATE = 'ropa_template:update',
  ROPA_TEMPLATE_DELETE = 'ropa_template:delete',
  ROPA_TICKET_REJECT = 'ropa_ticket:reject',
  ROPA_TICKET_REASSIGN = 'ropa_ticket:reassign',
  ROPA_REVIEW_SCHEDULE_UPDATE = 'ropa_review_schedule:update',
  DSR_ACTIONS = 'dsr:actions',
  ROLE_UPDATE = 'role:update',
  ALERTS_FULL_EDIT = 'alerts_full:edit',
  ALERTS_LIMITED_EDIT = 'alerts_limited:edit',
  ALERTS_AUDIT_LOGS_VIEW = 'alerts_audit_logs:view',
  ALERTS_AUDIT_LOGS_EDIT = 'alerts_audit_logs:edit',
  POLICY_ACTIONS = 'policy:actions',
  POLICY_DETAILS_EDIT = 'policy_details:edit',
  POLICY_DETAILS_DELETE = 'policy_details:delete',
  OBJECT_VIEWER_ACTIONS = 'object_viewer:actions',
  OBJECT_VIEWER_VIEW_PII_DATA = 'object_viewer:view_pii_data',
  OBJECT_VIEWER_TEMPLATE_ACTIONS = 'object_viewer:template_actions',
  USER_ACCESS_ACTIONS = 'userAccess:actions',
  TEMPLATE_ACTIONS = 'templates:actions',
  ENTITY_ACTIONS = 'entity:actions',

  OBJECTS_IMPACTED_ACTIONS = 'objects_impacted:actions',
  OBJECTS_IMPACTED_ASSIGN_REASSIGN = 'objects_impacted:assign_reassign',
  OBJECTS_IMPACTED_RESOLVE = 'objects_impacted:resolve',
  OBJECTS_IMPACTED_CHANGE_STATE = 'objects_impacted:change_state',
  OBJECTS_IMPACTED_DELETE = 'objects_impacted:delete',
  OBJECTS_IMPACTED_ARCHIVE = 'objects_impacted:archive',

  // NAV ACTIONS
  DASHBOARD_VIEW = 'dashboard:view',
  ATTRIBUTES_VIEW = 'attributes:view',
  DATA_SOURCE_VIEW = 'dataSource:view',
  DATA_SOURCE_EDIT = 'dataSource:edit',
  DATA_SOURCE_SETTINGS_VIEW = 'dataSource:settings_view',
  ALERTS_VIEW = 'alerts:view',
  SETTINGS_VIEW = 'settings:view',
  POLICY_PARAMETERS_VIEW = 'policy_params:view',
  PLAYBOOK_SETTINGS_VIEW = 'playbook_settings:view',
  RULE_SETS_VIEW = 'ruleSets:view',
  POLICIES_VIEW = 'policies:view',
  WORKFLOWS_VIEW = 'workflows:view',
  POLICY_WORKFLOWS_VIEW = 'policy_workflows:view',
  POLICY_WORKFLOW_EDIT = 'policy_workflow:edit',
  UAR_WORKFLOWS_VIEW = 'uar_workflows:view',
  UAR_WORKFLOW_EDIT = 'uar_workflow:edit',
  MY_ALERTS_VIEW = 'myAlerts:view',
  ALERTS_ALL_VIEW = 'alerts_all:view',
  FILES_VIEW = 'files:view',
  LABELS_VIEW = 'labels:view',
  REPORTS_VIEW = 'reports:view',
  LABELS_CREATE = 'labels:create',
  LABELS_ACTIONS = 'labels:actions',
  OBJECTS_VIEW = 'objects:view',
  CLASSIFICATIONS_VIEW = 'classifications:view',
  CLASSIFICATIONS_CREATE = 'classifications:create',
  TEMPLATES_VIEW = 'templates:view',
  ENTITIES_VIEW = 'entities:view',
  ENTITIES_EDIT = 'entities:edit',
  ENTITY_DETAILS_VIEW = 'entity_details:view',
  INSIGHTS_VIEW = 'insights:view',
  DSR_VIEW = 'dsr:view',
  ROPA_VIEW = 'ropa:view',
  PIA_VIEW = 'pia:view',
  PRIVACY_OPS_DASHBOARD = 'privacy_ops_dashboard:view',
  COOKIE_CONSENT_VIEW = 'cookie_consent:view',
  CONSENT_MANAGEMENT_VIEW = 'consent_management:view',
  CONSENT_MANAGEMENT_EDIT = 'consent_management:edit',
  ACCESS_CONTROL_VIEW = 'access_control:view',
  GOVERNANCE_VIEW = 'governance:view',
  GOVERNANCE_ACTIONS = 'governance:actions',
  ACCESS_REVIEW_VIEW = 'access_review:view',
  PRIVACY_PARTNERS = 'privacy_partners:view',
  OBJECT_VIEWER_FILE_VIEW = 'object_viewer_file:view',
  OBJECT_VIEWER_ATTRIBUTES_VIEW = 'object_viewer_attributes:view',
  OBJECT_VIEWER_MASK = 'object_viewer:mask',
  IDENTIFIERS_MASK = 'identifiers:mask',
  RISK_SCORE_CONFIGURE = 'risk_score:configure',
  ABOUT_VIEW = 'about:view',
  AUTH_PROVIDES_VIEW = 'auth_providers:view',
  AUTH_PROVIDER_EDIT = 'auth_provider:edit',
  SMTP_CONFIG_VIEW = 'smtp_config:view',
  SMTP_CONFIG_EDIT = 'smtp_config:edit',
  USER_MANAGEMENT_VIEW = 'user_management:view',
  ROLE_MANAGEMENT_VIEW = 'role_management:view',
  REPORT_CONFIG_VIEW = 'report_config:view',
  REPORT_CONFIG_EDIT = 'report_config:edit',
  RISK_SCORE_CONFIG_VIEW = 'risk_score_config:view',
  RISK_SCORE_CONFIG_EDIT = 'risk_score_config:edit',
  DSR_REQUEST_MANAGEMENT_VIEW = 'dsr_request_management:view',
  DSR_FORMS_VIEW = 'dsr_forms:view',
  DSR_WORKFLOW_AUTOMATION_VIEW = 'dsr_workflow_automation:view',
  DSR_EMAIL_TEMPLATES_VIEW = 'dsr_email_templates:view',
  DSR_REPORTS_VIEW = 'dsr_reports:view',
  DSR_TICKETS_VIEW = 'dsr_tickets:view',
  DSR_SETTINGS_VIEW = 'dsr_settings:view',
  PIA_PROCESSES_VIEW = 'pia_processes:view',
  PIA_TEMPLATES_VIEW = 'pia_templates:view',
  PIA_TEMPLATES_CREATE = 'pia_templates:create',
  PIA_TICKETS_VIEW = 'pia_tickets:view',
  PIA_REPORTS_VIEW = 'pia_reports:view',
  PIA_SETTINGS_VIEW = 'pia_settings:view',
  PIA_PROCESS_EDIT = 'pia_process:edit',
  PIA_PROCESS_EDIT_REVIEWER = 'pia_process:edit-reviewer',
  PIA_EDIT_GROUPS = 'pia:edit-groups',
  ROPA_PROCESSES_VIEW = 'ropa_processes:view',
  ROPA_TEMPLATES_VIEW = 'ropa_templates:view',
  ROPA_TICKETS_VIEW = 'ropa_tickets:view',
  ROPA_REPORTS_VIEW = 'ropa_reports:view',
  COOKIE_CONSENT_OVERVIEW_VIEW = 'cookie_consent_overview:view',
  COOKIE_CONSENT_DOMAINS_VIEW = 'cookie_consent_domains:view',
  COOKIE_CONSENT_BANNERS_VIEW = 'cookie_consent_banners:view',
  COOKIE_CONSENT_SETTINGS_VIEW = 'cookie_consent_settings:view',
  COOKIE_CONSENT_EDIT = 'cookie_consent:edit',
  PRIVACY_OPS_WIDGETS_VIEW = 'privacy_ops_widgets:view',
  NOTIFICATIONS_VIEW = 'notifications:view',
  MULTI_LANGUAGE_SUPPORT_VIEW = 'multi_language_support:view',
  DATASOURCE_ACTIONS = 'datasource:actions',
  TABLE_CLUSTER_ACTIONS = 'table_cluster:actions',

  USER_MANAGEMENT_EDIT = 'user_management:edit',
  ROLE_MANAGEMENT_EDIT = 'role_management:edit',

  DASHBOARD_ACTIONS = 'dashboard:actions',

  // DATA FILTER ACTIONS

  FILTER_DSR_ASSIGNEE_EMAIL = 'filter:dsr_assignee_email',
  /* Alert Owner specific */
  ALERT_FILTER_BY_VALUES = 'alert_filter_by_values',
  QUERY_SUB_ASSIGNEE_FILTER = 'query:sub_assignee_filter',
  /***** */

  QUERY_DS_OWNER_FILTER = 'query:ds_owner_filter'
}

export enum BACKEND_PERMISSIONS {
  DASHBOARDS_NO = 'dashboard:no',
  DASHBOARDS_VIEW = 'dashboard:read-only',
  DASHBOARDS_FULL = 'dashboard:full',

  OBJECT_VIEWER_NO = 'object-viewer:no',
  OBJECT_VIEWER_VIEW = 'object-viewer:read-only',
  OBJECT_VIEWER_FULL = 'object-viewer:full',

  PRIVACY_OPS_NO = 'privacy-ops:no',
  PRIVACY_OPS_VIEW = 'privacy-ops:read-only',
  PRIVACY_OPS_FULL = 'privacy-ops:full',

  ALERTS_NO = 'alerts:no',
  ALERTS_VIEW = 'alerts:read-only',
  ALERTS_LIMITED = 'alerts:limited', // does not have access to archive/delete files
  ALERTS_FULL = 'alerts:full',
  ALERTS_AUDIT_LOGS_NO = 'alerts-audit-logs:no',
  ALERTS_AUDIT_LOGS_READ_ONLY = 'alerts-audit-logs:read-only',
  ALERTS_AUDIT_LOGS_LIMITED = 'alerts-audit-logs:limited',
  ALERTS_AUDIT_LOGS_FULL = 'alerts-audit-logs:full',

  PRIVACY_OPS_DSR_NO = 'privacy-ops-dsr:no',
  PRIVACY_OPS_DSR_FULL = 'privacy-ops-dsr:full',

  PRIVACY_OPS_COOKIE_CONSENT_NO = 'privacy-ops-cookie-consent:no',
  PRIVACY_OPS_COOKIE_CONSENT_FULL = 'privacy-ops-cookie-consent:full',

  POLICIES_NO = `policies-and-ruleset:no`,
  POLICIES_VIEW = `policies-and-ruleset:read-only`,
  POLICIES_FULL = `policies-and-ruleset:full`,

  // actions for sub-alerts
  SUB_ALERTS_STATE_CHANGE = `sub-alert-management:state-changes`,
  SUB_ALERTS_ASSIGN_REASSIGN = `sub-alert-management:assign-reassign`,
  SUB_ALERTS_COMMENT = `sub-alert-management:comment`,
  SUB_ALERTS_RESOLVE = `sub-alert-management:resolve`,
  SUB_ALERTS_ARCHIVE = `sub-alert-management:archive`,
  SUB_ALERTS_DELETE = `sub-alert-management:delete`,
  SUB_ALERTS_REVOKE = `sub-alert-management:revoke-access`,

  ATTRIBUTES_NO = `attributes:no`,
  ATTRIBUTES_VIEW = `attributes:read-only`,
  ATTRIBUTES_FULL = `attributes:full`,

  LABELS_NO = `labels:no`,
  LABELS_VIEW = `labels:read-only`,
  LABELS_FULL = `labels:full`,

  TEMPLATES_NO = `templates:no`,
  TEMPLATES_VIEW = `templates:read-only`,
  TEMPLATES_FULL = `templates:full`,

  PRIVACY_OPS_CONSENT_MANAGEMENT_NO = 'privacy-ops-consent-management:no',
  PRIVACY_OPS_CONSENT_MANAGEMENT_FULL = 'privacy-ops-consent-management:full',

  PRIVACY_OPS_ROPA_PIA_REPORT_NO = 'ropa-pia-report:no',
  PRIVACY_OPS_ROPA_PIA_REPORT_LIMITED = 'ropa-pia-report:limited',
  PRIVACY_OPS_ROPA_PIA_REPORT_FULL = 'ropa-pia-report:full',

  PRIVACY_OPS_ROPA_PIA_REVIEW_NO = 'ropa-pia-review:no',
  PRIVACY_OPS_ROPA_PIA_REVIEW_LIMITED = 'ropa-pia-review:limited',

  PRIVACY_OPS_ROPA_PIA_TICKET_NO = 'ropa-pia-ticket:no',
  PRIVACY_OPS_ROPA_PIA_TICKET_LIMITED = 'ropa-pia-ticket:limited',

  PRIVACY_OPS_ROPA_PIA_TEMPLATE_NO = 'ropa-pia-template:no',
  PRIVACY_OPS_ROPA_PIA_TEMPLATE_LIMITED = 'ropa-pia-template:limited',
  PRIVACY_OPS_ROPA_PIA_TEMPLATE_FULL = 'ropa-pia-template:full',

  PRIVACY_OPS_ROPA_PIA_PROCESS_NO = 'ropa-pia-process:no',
  PRIVACY_OPS_ROPA_PIA_PROCESS_LIMITED = 'ropa-pia-process:limited',
  PRIVACY_OPS_ROPA_PIA_PROCESS_FULL = 'ropa-pia-process:full',

  REPORT_SETTINGS_NO = 'report-settings:no',
  REPORT_SETTINGS_READ_ONLY = 'report-settings:read-only',
  REPORT_SETTINGS_FULL = 'report-settings:full',

  AUTH_PROVIDER_NO = 'auth-provider-settings:no',
  AUTH_PROVIDER_READ_ONLY = 'auth-provider-settings:read-only',
  AUTH_PROVIDER_FULL = 'auth-provider-settings:full',

  SMTP_SETTINGS_NO = 'smtp-settings:no',
  SMTP_SETTINGS_READ_ONLY = 'smtp-settings:read-only',
  SMTP_SETTINGS_FULL = 'smtp-settings:full',

  RISK_SCORE_SETTINGS_NO = 'risk-score-settings:no',
  RISK_SCORE_SETTINGS_READ_ONLY = 'risk-score-settings:read-only',
  RISK_SCORE_SETTINGS_FULL = 'risk-score-settings:full',

  USER_MANAGEMENT_NO = 'user-management:no',
  USER_MANAGEMENT_READ_ONLY = 'user-management:read-only',
  USER_MANAGEMENT_FULL = 'user-management:full',
  ROLE_MANAGEMENT_NO = 'role-management:no',
  ROLE_MANAGEMENT_READ_ONLY = 'role-management:read-only',
  ROLE_MANAGEMENT_FULL = 'role-management:full',

  GOVERNANCE_NO = 'governance:no',
  GOVERNANCE_READ_ONLY = 'governance:read-only',
  GOVERNANCE_FULL = 'governance:full',

  OBJECTS_NO = 'objects:no',
  OBJECTS_READ_ONLY = 'objects:read-only',
  OBJECTS_FULL = 'objects:full',

  DOCUMENTS_NO = 'documents:no',
  DOCUMENTS_READ_ONLY = 'documents:read-only',
  DOCUMENTS_FULL = 'documents:full',

  USER_ENTITY_NO = 'user-entity:no',
  USER_ENTITY_READ_ONLY = 'user-entity:read-only',
  USER_ENTITY_FULL = 'user-entity:full',

  DATASOURCE_NO = 'datasource:no',
  DATASOURCE_READ_ONLY = 'datasource:read-only',
  DATASOURCE_FULL = 'datasource:full'
}

export type ActionToPermissionType = {
  scope?: ROLE_SCOPES | ROLE_SCOPES[]
  permissions?: BACKEND_PERMISSIONS[]
  /** Additional permission gate (AND-ed with permissions). User must satisfy at least one entry here AND at least one from permissions. */
  mandatoryPermissions?: BACKEND_PERMISSIONS[]
  isViewOnly?: boolean
  action?: string
}

export const actionToBackendPermissionMap: { [key: string]: ActionToPermissionType } = {
  [ACTIONS.DATASOURCE_ACTIONS]: {
    permissions: [BACKEND_PERMISSIONS.DATASOURCE_FULL],
    scope: [ROLE_SCOPES.datasource, ROLE_SCOPES.global, ROLE_SCOPES.custom],
    isViewOnly: false
  },
  [ACTIONS.DATA_SOURCE_EDIT]: {
    permissions: [BACKEND_PERMISSIONS.DATASOURCE_FULL],
    scope: [ROLE_SCOPES.datasource, ROLE_SCOPES.global, ROLE_SCOPES.custom],
    isViewOnly: false
  },
  [ACTIONS.TABLE_CLUSTER_ACTIONS]: {
    permissions: [BACKEND_PERMISSIONS.DATASOURCE_FULL],
    scope: [ROLE_SCOPES.datasource, ROLE_SCOPES.global, ROLE_SCOPES.custom],
    isViewOnly: false
  },
  [ACTIONS.DASHBOARD_ACTIONS]: {
    scope: [ROLE_SCOPES.global, ROLE_SCOPES.custom, ROLE_SCOPES.datasource],
    permissions: [BACKEND_PERMISSIONS.DASHBOARDS_FULL],
    isViewOnly: false
  },
  [ACTIONS.NOTIFICATIONS_CREATE]: {
    scope: ROLE_SCOPES.global
  },
  [ACTIONS.REPORT_CREATE]: {
    scope: [ROLE_SCOPES.global, ROLE_SCOPES.custom, ROLE_SCOPES.datasource, ROLE_SCOPES.alerts]
  },
  [ACTIONS.RULE_SET_CREATE]: {
    permissions: [BACKEND_PERMISSIONS.POLICIES_FULL],
    scope: [ROLE_SCOPES.datasource, ROLE_SCOPES.custom]
  },
  [ACTIONS.OBJECT_VIEWER_MASK]: {
    permissions: [BACKEND_PERMISSIONS.OBJECT_VIEWER_FULL],
    scope: [ROLE_SCOPES.datasource, ROLE_SCOPES.alerts, ROLE_SCOPES.custom]
  },
  [ACTIONS.IDENTIFIERS_MASK]: {
    scope: ROLE_SCOPES.datasource,
    isViewOnly: true
  },
  [ACTIONS.RISK_SCORE_CONFIGURE]: {
    scope: ROLE_SCOPES.datasource
  },
  [ACTIONS.PIA_TEMPLATES_CREATE]: {
    scope: [ROLE_SCOPES.datasource, ROLE_SCOPES.custom],
    permissions: [
      BACKEND_PERMISSIONS.PRIVACY_OPS_FULL,
      BACKEND_PERMISSIONS.PRIVACY_OPS_ROPA_PIA_TEMPLATE_FULL
    ],
    isViewOnly: true
  },
  [ACTIONS.PIA_PROCESS_EDIT]: {
    scope: [ROLE_SCOPES.datasource, ROLE_SCOPES.custom],
    permissions: [
      BACKEND_PERMISSIONS.PRIVACY_OPS_FULL,
      BACKEND_PERMISSIONS.PRIVACY_OPS_ROPA_PIA_PROCESS_FULL,
      BACKEND_PERMISSIONS.PRIVACY_OPS_ROPA_PIA_PROCESS_LIMITED
    ],
    isViewOnly: true
  },
  [ACTIONS.ROPA_PROCESS_CREATE]: {
    scope: [ROLE_SCOPES.datasource, ROLE_SCOPES.custom],
    permissions: [
      BACKEND_PERMISSIONS.PRIVACY_OPS_FULL,
      BACKEND_PERMISSIONS.PRIVACY_OPS_ROPA_PIA_PROCESS_FULL,
      BACKEND_PERMISSIONS.PRIVACY_OPS_ROPA_PIA_PROCESS_LIMITED
    ]
  },
  [ACTIONS.ROPA_PROCESS_CLONE]: {
    scope: [ROLE_SCOPES.datasource, ROLE_SCOPES.custom],
    permissions: [
      BACKEND_PERMISSIONS.PRIVACY_OPS_FULL,
      BACKEND_PERMISSIONS.PRIVACY_OPS_ROPA_PIA_PROCESS_FULL,
      BACKEND_PERMISSIONS.PRIVACY_OPS_ROPA_PIA_PROCESS_LIMITED
    ],
    isViewOnly: true
  },
  [ACTIONS.ROPA_PROCESS_UPDATE]: {
    scope: [ROLE_SCOPES.datasource, ROLE_SCOPES.custom],
    permissions: [
      BACKEND_PERMISSIONS.PRIVACY_OPS_FULL,
      BACKEND_PERMISSIONS.PRIVACY_OPS_ROPA_PIA_PROCESS_FULL,
      BACKEND_PERMISSIONS.PRIVACY_OPS_ROPA_PIA_PROCESS_LIMITED
    ],
    isViewOnly: true
  },
  [ACTIONS.ROPA_PROCESS_DELETE]: {
    scope: [ROLE_SCOPES.datasource, ROLE_SCOPES.custom],
    permissions: [
      BACKEND_PERMISSIONS.PRIVACY_OPS_FULL,
      BACKEND_PERMISSIONS.PRIVACY_OPS_ROPA_PIA_PROCESS_FULL,
      BACKEND_PERMISSIONS.PRIVACY_OPS_ROPA_PIA_PROCESS_LIMITED
    ],
    isViewOnly: true
  },
  [ACTIONS.ROPA_TEMPLATE_CLONE]: {
    scope: [ROLE_SCOPES.datasource, ROLE_SCOPES.custom],
    permissions: [
      BACKEND_PERMISSIONS.PRIVACY_OPS_FULL,
      BACKEND_PERMISSIONS.PRIVACY_OPS_ROPA_PIA_TEMPLATE_FULL,
      BACKEND_PERMISSIONS.PRIVACY_OPS_ROPA_PIA_TEMPLATE_LIMITED
    ],
    isViewOnly: true
  },
  [ACTIONS.ROPA_TEMPLATE_CREATE]: {
    scope: [ROLE_SCOPES.datasource, ROLE_SCOPES.custom],
    permissions: [
      BACKEND_PERMISSIONS.PRIVACY_OPS_FULL,
      BACKEND_PERMISSIONS.PRIVACY_OPS_ROPA_PIA_TEMPLATE_FULL
    ],
    isViewOnly: true
  },
  [ACTIONS.ROPA_TEMPLATE_UPDATE]: {
    scope: [ROLE_SCOPES.datasource, ROLE_SCOPES.custom],
    permissions: [
      BACKEND_PERMISSIONS.PRIVACY_OPS_FULL,
      BACKEND_PERMISSIONS.PRIVACY_OPS_ROPA_PIA_TEMPLATE_FULL,
      BACKEND_PERMISSIONS.PRIVACY_OPS_ROPA_PIA_TEMPLATE_LIMITED
    ],
    isViewOnly: true
  },
  [ACTIONS.ROPA_TEMPLATE_DELETE]: {
    scope: [ROLE_SCOPES.datasource, ROLE_SCOPES.custom],
    permissions: [
      BACKEND_PERMISSIONS.PRIVACY_OPS_FULL,
      BACKEND_PERMISSIONS.PRIVACY_OPS_ROPA_PIA_TEMPLATE_FULL
    ],
    isViewOnly: true
  },
  [ACTIONS.ROPA_TICKET_REJECT]: {
    scope: [ROLE_SCOPES.datasource, ROLE_SCOPES.custom],
    permissions: [
      BACKEND_PERMISSIONS.PRIVACY_OPS_FULL,
      BACKEND_PERMISSIONS.PRIVACY_OPS_ROPA_PIA_TICKET_LIMITED
    ],
    isViewOnly: true
  },
  [ACTIONS.ROPA_TICKET_REASSIGN]: {
    scope: [ROLE_SCOPES.datasource, ROLE_SCOPES.custom],
    permissions: [
      BACKEND_PERMISSIONS.PRIVACY_OPS_FULL,
      BACKEND_PERMISSIONS.PRIVACY_OPS_ROPA_PIA_TICKET_LIMITED
    ],
    isViewOnly: true
  },
  [ACTIONS.ROPA_REVIEW_SCHEDULE_UPDATE]: {
    scope: [ROLE_SCOPES.datasource, ROLE_SCOPES.custom],
    permissions: [
      BACKEND_PERMISSIONS.PRIVACY_OPS_FULL,
      BACKEND_PERMISSIONS.PRIVACY_OPS_ROPA_PIA_PROCESS_FULL,
      BACKEND_PERMISSIONS.PRIVACY_OPS_ROPA_PIA_PROCESS_LIMITED
    ],
    isViewOnly: true
  },
  [ACTIONS.PIA_PROCESS_EDIT_REVIEWER]: {
    scope: [ROLE_SCOPES.datasource, ROLE_SCOPES.custom],
    permissions: [
      BACKEND_PERMISSIONS.PRIVACY_OPS_FULL,
      BACKEND_PERMISSIONS.PRIVACY_OPS_ROPA_PIA_PROCESS_FULL
    ],
    isViewOnly: true
  },
  [ACTIONS.PIA_EDIT_GROUPS]: {
    scope: [ROLE_SCOPES.datasource, ROLE_SCOPES.custom],
    permissions: [
      BACKEND_PERMISSIONS.PRIVACY_OPS_FULL,
      BACKEND_PERMISSIONS.PRIVACY_OPS_ROPA_PIA_PROCESS_FULL,
      BACKEND_PERMISSIONS.PRIVACY_OPS_ROPA_PIA_PROCESS_LIMITED
    ]
  },
  [ACTIONS.DSR_ACTIONS]: {
    scope: [ROLE_SCOPES.datasource, ROLE_SCOPES.custom],
    permissions: [BACKEND_PERMISSIONS.PRIVACY_OPS_FULL, BACKEND_PERMISSIONS.PRIVACY_OPS_DSR_FULL],
    isViewOnly: true
  },
  [ACTIONS.ALERTS_MUTE]: {
    permissions: [BACKEND_PERMISSIONS.ALERTS_FULL, BACKEND_PERMISSIONS.ALERTS_LIMITED],
    scope: [ROLE_SCOPES.datasource, ROLE_SCOPES.alerts, ROLE_SCOPES.custom]
  },
  [ACTIONS.ALERTS_ASSIGNMENT]: {
    permissions: [BACKEND_PERMISSIONS.ALERTS_FULL, BACKEND_PERMISSIONS.ALERTS_LIMITED],
    scope: [ROLE_SCOPES.datasource, ROLE_SCOPES.alerts, ROLE_SCOPES.custom]
  },
  [ACTIONS.ALERTS_RESOLUTION]: {
    permissions: [BACKEND_PERMISSIONS.ALERTS_FULL, BACKEND_PERMISSIONS.ALERTS_LIMITED],
    scope: [ROLE_SCOPES.datasource, ROLE_SCOPES.alerts, ROLE_SCOPES.custom]
  },
  [ACTIONS.ATTRIBUTE_SET_UPDATE]: {
    scope: [ROLE_SCOPES.global, ROLE_SCOPES.custom],
    permissions: [BACKEND_PERMISSIONS.ATTRIBUTES_FULL]
  },
  [ACTIONS.ATTRIBUTE_SET_CREATE]: {
    scope: [ROLE_SCOPES.global, ROLE_SCOPES.custom],
    permissions: [BACKEND_PERMISSIONS.ATTRIBUTES_FULL],
    isViewOnly: false
  },

  [ACTIONS.LABELS_CREATE]: {
    scope: [ROLE_SCOPES.global, ROLE_SCOPES.custom],
    permissions: [BACKEND_PERMISSIONS.LABELS_FULL],
    isViewOnly: false
  },
  [ACTIONS.LABELS_ACTIONS]: {
    scope: [ROLE_SCOPES.global, ROLE_SCOPES.custom],
    permissions: [BACKEND_PERMISSIONS.LABELS_FULL],
    isViewOnly: false
  },
  [ACTIONS.CLASSIFICATIONS_CREATE]: {
    scope: [ROLE_SCOPES.global, ROLE_SCOPES.custom],
    permissions: [BACKEND_PERMISSIONS.DOCUMENTS_FULL],
    isViewOnly: false
  },
  [ACTIONS.USER_MANAGEMENT_EDIT]: {
    permissions: [BACKEND_PERMISSIONS.USER_MANAGEMENT_FULL],
    scope: [ROLE_SCOPES.global, ROLE_SCOPES.custom],
    isViewOnly: false
  },
  [ACTIONS.ROLE_MANAGEMENT_EDIT]: {
    permissions: [BACKEND_PERMISSIONS.ROLE_MANAGEMENT_FULL],
    scope: [ROLE_SCOPES.global, ROLE_SCOPES.custom],
    isViewOnly: false
  },

  [ACTIONS.ALERTS_FULL_EDIT]: {
    scope: [ROLE_SCOPES.datasource, ROLE_SCOPES.alerts, ROLE_SCOPES.custom],
    permissions: [BACKEND_PERMISSIONS.ALERTS_FULL]
  },
  [ACTIONS.ALERTS_LIMITED_EDIT]: {
    scope: [ROLE_SCOPES.datasource, ROLE_SCOPES.alerts, ROLE_SCOPES.custom],
    permissions: [BACKEND_PERMISSIONS.ALERTS_FULL, BACKEND_PERMISSIONS.ALERTS_LIMITED]
  },
  [ACTIONS.ALERTS_AUDIT_LOGS_EDIT]: {
    scope: [ROLE_SCOPES.datasource, ROLE_SCOPES.alerts, ROLE_SCOPES.custom],
    permissions: [BACKEND_PERMISSIONS.ALERTS_AUDIT_LOGS_FULL]
  },
  [ACTIONS.OBJECTS_IMPACTED_ACTIONS]: {
    scope: [ROLE_SCOPES.datasource, ROLE_SCOPES.alerts, ROLE_SCOPES.custom],
    permissions: [BACKEND_PERMISSIONS.ALERTS_FULL, BACKEND_PERMISSIONS.ALERTS_LIMITED],
    isViewOnly: false
  },
  [ACTIONS.OBJECTS_IMPACTED_ASSIGN_REASSIGN]: {
    scope: [ROLE_SCOPES.datasource, ROLE_SCOPES.alerts, ROLE_SCOPES.custom],
    permissions: [BACKEND_PERMISSIONS.SUB_ALERTS_ASSIGN_REASSIGN],
    mandatoryPermissions: [BACKEND_PERMISSIONS.ALERTS_FULL, BACKEND_PERMISSIONS.ALERTS_LIMITED],
    isViewOnly: false
  },
  [ACTIONS.OBJECTS_IMPACTED_RESOLVE]: {
    scope: [ROLE_SCOPES.datasource, ROLE_SCOPES.alerts, ROLE_SCOPES.custom],
    permissions: [BACKEND_PERMISSIONS.SUB_ALERTS_RESOLVE],
    mandatoryPermissions: [BACKEND_PERMISSIONS.ALERTS_FULL, BACKEND_PERMISSIONS.ALERTS_LIMITED],
    isViewOnly: false
  },
  [ACTIONS.OBJECTS_IMPACTED_CHANGE_STATE]: {
    scope: [ROLE_SCOPES.datasource, ROLE_SCOPES.alerts, ROLE_SCOPES.custom],
    permissions: [BACKEND_PERMISSIONS.SUB_ALERTS_STATE_CHANGE],
    mandatoryPermissions: [BACKEND_PERMISSIONS.ALERTS_FULL, BACKEND_PERMISSIONS.ALERTS_LIMITED],
    isViewOnly: false
  },
  [ACTIONS.OBJECTS_IMPACTED_DELETE]: {
    scope: [ROLE_SCOPES.datasource, ROLE_SCOPES.alerts, ROLE_SCOPES.custom],
    permissions: [BACKEND_PERMISSIONS.SUB_ALERTS_DELETE],
    mandatoryPermissions: [BACKEND_PERMISSIONS.ALERTS_FULL, BACKEND_PERMISSIONS.ALERTS_LIMITED],
    isViewOnly: false
  },
  [ACTIONS.OBJECTS_IMPACTED_ARCHIVE]: {
    scope: [ROLE_SCOPES.datasource, ROLE_SCOPES.alerts, ROLE_SCOPES.custom],
    permissions: [BACKEND_PERMISSIONS.SUB_ALERTS_ARCHIVE],
    mandatoryPermissions: [BACKEND_PERMISSIONS.ALERTS_FULL, BACKEND_PERMISSIONS.ALERTS_LIMITED],
    isViewOnly: false
  },
  [ACTIONS.POLICY_DETAILS_EDIT]: {
    scope: [ROLE_SCOPES.datasource, ROLE_SCOPES.custom],
    permissions: [BACKEND_PERMISSIONS.POLICIES_FULL],
    isViewOnly: false
  },
  [ACTIONS.POLICY_ACTIONS]: {
    scope: [ROLE_SCOPES.datasource, ROLE_SCOPES.custom],
    permissions: [BACKEND_PERMISSIONS.POLICIES_FULL],
    isViewOnly: false
  },
  [ACTIONS.POLICY_DETAILS_DELETE]: {
    scope: [ROLE_SCOPES.datasource, ROLE_SCOPES.custom],
    permissions: [BACKEND_PERMISSIONS.POLICIES_FULL],
    isViewOnly: false
  },
  [ACTIONS.POLICY_WORKFLOW_EDIT]: {
    scope: [ROLE_SCOPES.datasource, ROLE_SCOPES.custom],
    permissions: [BACKEND_PERMISSIONS.POLICIES_FULL],
    isViewOnly: false
  },
  [ACTIONS.OBJECT_VIEWER_ACTIONS]: {
    scope: [ROLE_SCOPES.datasource, ROLE_SCOPES.custom],
    permissions: [BACKEND_PERMISSIONS.OBJECT_VIEWER_FULL],
    isViewOnly: false
  },
  [ACTIONS.OBJECT_VIEWER_VIEW_PII_DATA]: {
    scope: [ROLE_SCOPES.datasource, ROLE_SCOPES.alerts, ROLE_SCOPES.custom],
    permissions: [BACKEND_PERMISSIONS.OBJECT_VIEWER_FULL, BACKEND_PERMISSIONS.OBJECT_VIEWER_VIEW],
    isViewOnly: true
  },
  [ACTIONS.OBJECT_VIEWER_TEMPLATE_ACTIONS]: {
    scope: [ROLE_SCOPES.global, ROLE_SCOPES.custom],
    permissions: [BACKEND_PERMISSIONS.OBJECT_VIEWER_FULL],
    isViewOnly: false
  },
  [ACTIONS.USER_ACCESS_ACTIONS]: {
    permissions: [BACKEND_PERMISSIONS.GOVERNANCE_FULL],
    scope: [ROLE_SCOPES.global, ROLE_SCOPES.custom],
    isViewOnly: false
  },
  [ACTIONS.GOVERNANCE_ACTIONS]: {
    permissions: [BACKEND_PERMISSIONS.GOVERNANCE_FULL],
    scope: [ROLE_SCOPES.global, ROLE_SCOPES.custom],
    isViewOnly: false
  },
  [ACTIONS.UAR_WORKFLOW_EDIT]: {
    permissions: [BACKEND_PERMISSIONS.GOVERNANCE_FULL],
    scope: [ROLE_SCOPES.global, ROLE_SCOPES.custom],
    isViewOnly: false
  },
  [ACTIONS.TEMPLATE_ACTIONS]: {
    scope: [ROLE_SCOPES.global, ROLE_SCOPES.custom],
    permissions: [BACKEND_PERMISSIONS.TEMPLATES_FULL],
    isViewOnly: false
  },
  [ACTIONS.ENTITY_ACTIONS]: {
    scope: [ROLE_SCOPES.global, ROLE_SCOPES.custom],
    isViewOnly: false
  },
  [ACTIONS.ENTITIES_EDIT]: {
    permissions: [BACKEND_PERMISSIONS.USER_ENTITY_FULL],
    scope: [ROLE_SCOPES.global, ROLE_SCOPES.custom]
  },

  [ACTIONS.CONSENT_MANAGEMENT_EDIT]: {
    scope: [ROLE_SCOPES.datasource, ROLE_SCOPES.custom],
    permissions: [
      BACKEND_PERMISSIONS.PRIVACY_OPS_FULL,
      BACKEND_PERMISSIONS.PRIVACY_OPS_CONSENT_MANAGEMENT_FULL
    ],
    isViewOnly: true
  },
  [ACTIONS.GLOBAL_SEARCH]: {
    scope: [ROLE_SCOPES.datasource],
    isViewOnly: true
  },
  [ACTIONS.COOKIE_CONSENT_EDIT]: {
    scope: [ROLE_SCOPES.datasource, ROLE_SCOPES.custom],
    permissions: [
      BACKEND_PERMISSIONS.PRIVACY_OPS_FULL,
      BACKEND_PERMISSIONS.PRIVACY_OPS_COOKIE_CONSENT_FULL
    ],
    isViewOnly: true
  },
  [ACTIONS.REPORT_CONFIG_EDIT]: {
    permissions: [BACKEND_PERMISSIONS.REPORT_SETTINGS_FULL],
    scope: [ROLE_SCOPES.global, ROLE_SCOPES.custom]
  },
  [ACTIONS.AUTH_PROVIDER_EDIT]: {
    permissions: [BACKEND_PERMISSIONS.AUTH_PROVIDER_FULL],
    scope: [ROLE_SCOPES.global, ROLE_SCOPES.custom]
  },
  [ACTIONS.SMTP_CONFIG_EDIT]: {
    permissions: [BACKEND_PERMISSIONS.SMTP_SETTINGS_FULL],
    scope: [ROLE_SCOPES.global, ROLE_SCOPES.custom]
  },
  [ACTIONS.RISK_SCORE_CONFIG_EDIT]: {
    permissions: [BACKEND_PERMISSIONS.RISK_SCORE_SETTINGS_FULL],
    scope: [ROLE_SCOPES.global, ROLE_SCOPES.custom]
  }
}

export const dataFilterToPermissionMap: { [key: string]: ActionToPermissionType } = {
  [ACTIONS.FILTER_DSR_ASSIGNEE_EMAIL]: {
    permissions: [BACKEND_PERMISSIONS.PRIVACY_OPS_FULL],
    scope: [ROLE_SCOPES.global, ROLE_SCOPES.custom]
  },
  /** Alert Owner specific */
  [ACTIONS.QUERY_SUB_ASSIGNEE_FILTER]: {
    scope: [ROLE_SCOPES.global, ROLE_SCOPES.datasource, ROLE_SCOPES.alerts, ROLE_SCOPES.custom],
    permissions: [BACKEND_PERMISSIONS.ALERTS_LIMITED]
  },
  [ACTIONS.ALERT_FILTER_BY_VALUES]: {
    scope: [ROLE_SCOPES.global, ROLE_SCOPES.datasource, ROLE_SCOPES.alerts, ROLE_SCOPES.custom],
    permissions: [BACKEND_PERMISSIONS.ALERTS_LIMITED]
  },

  /** */

  [ACTIONS.QUERY_DS_OWNER_FILTER]: { scope: ROLE_SCOPES.datasource }
}

export const navActionToPermissionMap: { [key: string]: ActionToPermissionType } = {
  // global
  [ACTIONS.DASHBOARD_VIEW]: {
    scope: [ROLE_SCOPES.global, ROLE_SCOPES.custom],
    permissions: [BACKEND_PERMISSIONS.DASHBOARDS_FULL, BACKEND_PERMISSIONS.DASHBOARDS_VIEW]
  },
  [ACTIONS.DATA_SOURCE_VIEW]: {
    scope: [ROLE_SCOPES.datasource, ROLE_SCOPES.global, ROLE_SCOPES.custom],
    permissions: [BACKEND_PERMISSIONS.DATASOURCE_FULL, BACKEND_PERMISSIONS.DATASOURCE_READ_ONLY]
  },
  [ACTIONS.DATA_SOURCE_SETTINGS_VIEW]: {
    scope: [ROLE_SCOPES.datasource, ROLE_SCOPES.global, ROLE_SCOPES.custom],
    permissions: [BACKEND_PERMISSIONS.DATASOURCE_FULL]
  },
  [ACTIONS.SETTINGS_VIEW]: { scope: [ROLE_SCOPES.global, ROLE_SCOPES.custom] },

  // privacy ops
  [ACTIONS.ROPA_VIEW]: {
    scope: [ROLE_SCOPES.datasource, ROLE_SCOPES.custom],
    permissions: [
      BACKEND_PERMISSIONS.PRIVACY_OPS_FULL,
      BACKEND_PERMISSIONS.PRIVACY_OPS_ROPA_PIA_PROCESS_FULL,
      BACKEND_PERMISSIONS.PRIVACY_OPS_ROPA_PIA_PROCESS_LIMITED,
      BACKEND_PERMISSIONS.PRIVACY_OPS_ROPA_PIA_TEMPLATE_FULL,
      BACKEND_PERMISSIONS.PRIVACY_OPS_ROPA_PIA_TEMPLATE_LIMITED,
      BACKEND_PERMISSIONS.PRIVACY_OPS_ROPA_PIA_REPORT_FULL,
      BACKEND_PERMISSIONS.PRIVACY_OPS_ROPA_PIA_REPORT_LIMITED,
      BACKEND_PERMISSIONS.PRIVACY_OPS_ROPA_PIA_REVIEW_LIMITED,
      BACKEND_PERMISSIONS.PRIVACY_OPS_ROPA_PIA_TICKET_LIMITED
    ]
  },
  [ACTIONS.PIA_VIEW]: {
    scope: [ROLE_SCOPES.datasource, ROLE_SCOPES.custom],
    permissions: [
      BACKEND_PERMISSIONS.PRIVACY_OPS_FULL,
      BACKEND_PERMISSIONS.PRIVACY_OPS_ROPA_PIA_PROCESS_FULL,
      BACKEND_PERMISSIONS.PRIVACY_OPS_ROPA_PIA_PROCESS_LIMITED,
      BACKEND_PERMISSIONS.PRIVACY_OPS_ROPA_PIA_TEMPLATE_FULL,
      BACKEND_PERMISSIONS.PRIVACY_OPS_ROPA_PIA_TEMPLATE_LIMITED,
      BACKEND_PERMISSIONS.PRIVACY_OPS_ROPA_PIA_REPORT_FULL,
      BACKEND_PERMISSIONS.PRIVACY_OPS_ROPA_PIA_REPORT_LIMITED,
      BACKEND_PERMISSIONS.PRIVACY_OPS_ROPA_PIA_REVIEW_LIMITED,
      BACKEND_PERMISSIONS.PRIVACY_OPS_ROPA_PIA_TICKET_LIMITED
    ]
  },
  [ACTIONS.PRIVACY_OPS_DASHBOARD]: {
    scope: [ROLE_SCOPES.datasource, ROLE_SCOPES.custom],
    permissions: [
      BACKEND_PERMISSIONS.PRIVACY_OPS_FULL,
      BACKEND_PERMISSIONS.PRIVACY_OPS_DSR_FULL,
      BACKEND_PERMISSIONS.PRIVACY_OPS_CONSENT_MANAGEMENT_FULL,
      BACKEND_PERMISSIONS.PRIVACY_OPS_COOKIE_CONSENT_FULL
    ]
  },
  [ACTIONS.COOKIE_CONSENT_VIEW]: {
    scope: [ROLE_SCOPES.datasource, ROLE_SCOPES.custom],
    permissions: [
      BACKEND_PERMISSIONS.PRIVACY_OPS_FULL,
      BACKEND_PERMISSIONS.PRIVACY_OPS_COOKIE_CONSENT_FULL
    ]
  },
  [ACTIONS.CONSENT_MANAGEMENT_VIEW]: {
    scope: [ROLE_SCOPES.datasource, ROLE_SCOPES.custom],
    permissions: [
      BACKEND_PERMISSIONS.PRIVACY_OPS_FULL,
      BACKEND_PERMISSIONS.PRIVACY_OPS_CONSENT_MANAGEMENT_FULL
    ]
  },
  [ACTIONS.PRIVACY_OPS_WIDGETS_VIEW]: {
    permissions: [BACKEND_PERMISSIONS.PRIVACY_OPS_FULL],
    scope: [ROLE_SCOPES.datasource, ROLE_SCOPES.custom]
  },

  // dsr
  [ACTIONS.DSR_VIEW]: {
    scope: [ROLE_SCOPES.datasource, ROLE_SCOPES.custom],
    permissions: [BACKEND_PERMISSIONS.PRIVACY_OPS_FULL, BACKEND_PERMISSIONS.PRIVACY_OPS_DSR_FULL]
  },
  [ACTIONS.DSR_REQUEST_MANAGEMENT_VIEW]: {
    scope: [ROLE_SCOPES.datasource, ROLE_SCOPES.custom],
    permissions: [BACKEND_PERMISSIONS.PRIVACY_OPS_FULL, BACKEND_PERMISSIONS.PRIVACY_OPS_DSR_FULL]
  },
  [ACTIONS.DSR_FORMS_VIEW]: {
    scope: [ROLE_SCOPES.datasource, ROLE_SCOPES.custom],
    permissions: [BACKEND_PERMISSIONS.PRIVACY_OPS_FULL, BACKEND_PERMISSIONS.PRIVACY_OPS_DSR_FULL]
  },
  [ACTIONS.DSR_WORKFLOW_AUTOMATION_VIEW]: {
    scope: [ROLE_SCOPES.datasource, ROLE_SCOPES.custom],
    permissions: [BACKEND_PERMISSIONS.PRIVACY_OPS_FULL, BACKEND_PERMISSIONS.PRIVACY_OPS_DSR_FULL]
  },
  [ACTIONS.DSR_REPORTS_VIEW]: {
    scope: [ROLE_SCOPES.datasource, ROLE_SCOPES.custom],
    permissions: [BACKEND_PERMISSIONS.PRIVACY_OPS_FULL, BACKEND_PERMISSIONS.PRIVACY_OPS_DSR_FULL]
  },
  [ACTIONS.DSR_TICKETS_VIEW]: {
    scope: [ROLE_SCOPES.datasource, ROLE_SCOPES.custom],
    permissions: [BACKEND_PERMISSIONS.PRIVACY_OPS_FULL, BACKEND_PERMISSIONS.PRIVACY_OPS_DSR_FULL]
  },
  [ACTIONS.DSR_EMAIL_TEMPLATES_VIEW]: {
    scope: [ROLE_SCOPES.datasource, ROLE_SCOPES.custom],
    permissions: [BACKEND_PERMISSIONS.PRIVACY_OPS_FULL, BACKEND_PERMISSIONS.PRIVACY_OPS_DSR_FULL]
  },
  [ACTIONS.DSR_SETTINGS_VIEW]: {
    scope: [ROLE_SCOPES.datasource, ROLE_SCOPES.custom],
    permissions: [BACKEND_PERMISSIONS.PRIVACY_OPS_FULL, BACKEND_PERMISSIONS.PRIVACY_OPS_DSR_FULL]
  },

  // pia
  [ACTIONS.PIA_PROCESSES_VIEW]: {
    scope: [ROLE_SCOPES.datasource, ROLE_SCOPES.custom],
    permissions: [
      BACKEND_PERMISSIONS.PRIVACY_OPS_FULL,
      BACKEND_PERMISSIONS.PRIVACY_OPS_ROPA_PIA_PROCESS_FULL,
      BACKEND_PERMISSIONS.PRIVACY_OPS_ROPA_PIA_PROCESS_LIMITED
    ]
  },
  [ACTIONS.PIA_TEMPLATES_VIEW]: {
    scope: [ROLE_SCOPES.datasource, ROLE_SCOPES.custom],
    permissions: [
      BACKEND_PERMISSIONS.PRIVACY_OPS_FULL,
      BACKEND_PERMISSIONS.PRIVACY_OPS_ROPA_PIA_TEMPLATE_FULL,
      BACKEND_PERMISSIONS.PRIVACY_OPS_ROPA_PIA_TEMPLATE_LIMITED
    ]
  },
  [ACTIONS.PIA_TICKETS_VIEW]: {
    scope: [ROLE_SCOPES.datasource, ROLE_SCOPES.custom],
    permissions: [
      BACKEND_PERMISSIONS.PRIVACY_OPS_FULL,
      BACKEND_PERMISSIONS.PRIVACY_OPS_ROPA_PIA_TICKET_LIMITED
    ]
  },
  [ACTIONS.PIA_REPORTS_VIEW]: {
    scope: [ROLE_SCOPES.datasource, ROLE_SCOPES.custom],
    permissions: [
      BACKEND_PERMISSIONS.PRIVACY_OPS_FULL,
      BACKEND_PERMISSIONS.PRIVACY_OPS_ROPA_PIA_REPORT_FULL,
      BACKEND_PERMISSIONS.PRIVACY_OPS_ROPA_PIA_REPORT_LIMITED
    ]
  },
  [ACTIONS.PIA_SETTINGS_VIEW]: {
    scope: [ROLE_SCOPES.datasource, ROLE_SCOPES.custom],
    permissions: [
      BACKEND_PERMISSIONS.PRIVACY_OPS_FULL,
      BACKEND_PERMISSIONS.PRIVACY_OPS_ROPA_PIA_PROCESS_FULL
    ]
  },

  // ropa
  [ACTIONS.ROPA_PROCESSES_VIEW]: {
    scope: [ROLE_SCOPES.datasource, ROLE_SCOPES.custom],
    permissions: [
      BACKEND_PERMISSIONS.PRIVACY_OPS_FULL,
      BACKEND_PERMISSIONS.PRIVACY_OPS_ROPA_PIA_PROCESS_FULL,
      BACKEND_PERMISSIONS.PRIVACY_OPS_ROPA_PIA_PROCESS_LIMITED
    ]
  },
  [ACTIONS.ROPA_TEMPLATES_VIEW]: {
    scope: [ROLE_SCOPES.datasource, ROLE_SCOPES.custom],
    permissions: [
      BACKEND_PERMISSIONS.PRIVACY_OPS_FULL,
      BACKEND_PERMISSIONS.PRIVACY_OPS_ROPA_PIA_TEMPLATE_FULL,
      BACKEND_PERMISSIONS.PRIVACY_OPS_ROPA_PIA_TEMPLATE_LIMITED
    ]
  },
  [ACTIONS.ROPA_TICKETS_VIEW]: {
    scope: [ROLE_SCOPES.datasource, ROLE_SCOPES.custom],
    permissions: [
      BACKEND_PERMISSIONS.PRIVACY_OPS_FULL,
      BACKEND_PERMISSIONS.PRIVACY_OPS_ROPA_PIA_TICKET_LIMITED
    ]
  },
  [ACTIONS.ROPA_REPORTS_VIEW]: {
    scope: [ROLE_SCOPES.datasource, ROLE_SCOPES.custom],
    permissions: [
      BACKEND_PERMISSIONS.PRIVACY_OPS_FULL,
      BACKEND_PERMISSIONS.PRIVACY_OPS_ROPA_PIA_REPORT_FULL,
      BACKEND_PERMISSIONS.PRIVACY_OPS_ROPA_PIA_REPORT_LIMITED
    ]
  },

  // cookie consent
  [ACTIONS.COOKIE_CONSENT_OVERVIEW_VIEW]: {
    scope: [ROLE_SCOPES.datasource, ROLE_SCOPES.custom],
    permissions: [
      BACKEND_PERMISSIONS.PRIVACY_OPS_FULL,
      BACKEND_PERMISSIONS.PRIVACY_OPS_COOKIE_CONSENT_FULL
    ]
  },
  [ACTIONS.COOKIE_CONSENT_DOMAINS_VIEW]: {
    scope: [ROLE_SCOPES.datasource, ROLE_SCOPES.custom],
    permissions: [
      BACKEND_PERMISSIONS.PRIVACY_OPS_FULL,
      BACKEND_PERMISSIONS.PRIVACY_OPS_COOKIE_CONSENT_FULL
    ]
  },
  [ACTIONS.COOKIE_CONSENT_BANNERS_VIEW]: {
    scope: [ROLE_SCOPES.datasource, ROLE_SCOPES.custom],
    permissions: [
      BACKEND_PERMISSIONS.PRIVACY_OPS_FULL,
      BACKEND_PERMISSIONS.PRIVACY_OPS_COOKIE_CONSENT_FULL
    ]
  },
  [ACTIONS.COOKIE_CONSENT_SETTINGS_VIEW]: {
    scope: [ROLE_SCOPES.datasource, ROLE_SCOPES.custom],
    permissions: [
      BACKEND_PERMISSIONS.PRIVACY_OPS_FULL,
      BACKEND_PERMISSIONS.PRIVACY_OPS_COOKIE_CONSENT_FULL
    ]
  },

  // insights
  [ACTIONS.ATTRIBUTES_VIEW]: {
    scope: [ROLE_SCOPES.global, ROLE_SCOPES.custom],
    permissions: [BACKEND_PERMISSIONS.ATTRIBUTES_FULL, BACKEND_PERMISSIONS.ATTRIBUTES_VIEW]
  },
  [ACTIONS.FILES_VIEW]: {
    scope: [ROLE_SCOPES.global, ROLE_SCOPES.datasource, ROLE_SCOPES.alerts, ROLE_SCOPES.custom],
    permissions: [BACKEND_PERMISSIONS.OBJECT_VIEWER_FULL, BACKEND_PERMISSIONS.OBJECT_VIEWER_VIEW]
  },
  [ACTIONS.LABELS_VIEW]: {
    scope: [ROLE_SCOPES.global, ROLE_SCOPES.custom],
    permissions: [BACKEND_PERMISSIONS.LABELS_FULL, BACKEND_PERMISSIONS.LABELS_VIEW]
  },
  [ACTIONS.OBJECTS_VIEW]: {
    scope: [ROLE_SCOPES.global, ROLE_SCOPES.custom],
    permissions: [BACKEND_PERMISSIONS.OBJECTS_FULL, BACKEND_PERMISSIONS.OBJECTS_READ_ONLY]
  },
  [ACTIONS.CLASSIFICATIONS_VIEW]: {
    scope: [ROLE_SCOPES.global, ROLE_SCOPES.custom],
    permissions: [BACKEND_PERMISSIONS.DOCUMENTS_FULL, BACKEND_PERMISSIONS.DOCUMENTS_READ_ONLY]
  },
  [ACTIONS.TEMPLATES_VIEW]: {
    scope: [ROLE_SCOPES.global, ROLE_SCOPES.custom],
    permissions: [BACKEND_PERMISSIONS.TEMPLATES_FULL, BACKEND_PERMISSIONS.TEMPLATES_VIEW]
  },
  [ACTIONS.ENTITIES_VIEW]: {
    scope: [ROLE_SCOPES.global, ROLE_SCOPES.custom],
    permissions: [BACKEND_PERMISSIONS.USER_ENTITY_FULL, BACKEND_PERMISSIONS.USER_ENTITY_READ_ONLY]
  },
  [ACTIONS.ENTITY_DETAILS_VIEW]: { scope: [ROLE_SCOPES.global, ROLE_SCOPES.custom] },
  [ACTIONS.INSIGHTS_VIEW]: { scope: [ROLE_SCOPES.global, ROLE_SCOPES.custom] },

  // access control
  [ACTIONS.GOVERNANCE_VIEW]: {
    scope: [ROLE_SCOPES.global, ROLE_SCOPES.custom],
    permissions: [BACKEND_PERMISSIONS.GOVERNANCE_FULL, BACKEND_PERMISSIONS.GOVERNANCE_READ_ONLY]
  },
  [ACTIONS.ACCESS_REVIEW_VIEW]: {
    scope: [ROLE_SCOPES.global, ROLE_SCOPES.custom],
    permissions: [BACKEND_PERMISSIONS.GOVERNANCE_FULL, BACKEND_PERMISSIONS.GOVERNANCE_READ_ONLY]
  },
  [ACTIONS.ACCESS_CONTROL_VIEW]: { scope: [ROLE_SCOPES.global, ROLE_SCOPES.custom] },
  [ACTIONS.PRIVACY_PARTNERS]: { scope: ROLE_SCOPES.global },

  // policies
  [ACTIONS.ALERTS_VIEW]: {
    scope: [ROLE_SCOPES.custom, ROLE_SCOPES.alerts, ROLE_SCOPES.datasource],
    permissions: [
      BACKEND_PERMISSIONS.ALERTS_FULL,
      BACKEND_PERMISSIONS.ALERTS_LIMITED,
      BACKEND_PERMISSIONS.ALERTS_VIEW
    ]
  },
  [ACTIONS.RULE_SETS_VIEW]: {
    scope: [ROLE_SCOPES.datasource, ROLE_SCOPES.alerts, ROLE_SCOPES.custom],
    permissions: [
      BACKEND_PERMISSIONS.ALERTS_LIMITED,
      BACKEND_PERMISSIONS.ALERTS_FULL,
      BACKEND_PERMISSIONS.ALERTS_VIEW,
      BACKEND_PERMISSIONS.POLICIES_FULL,
      BACKEND_PERMISSIONS.POLICIES_VIEW
    ]
  },
  [ACTIONS.WORKFLOWS_VIEW]: {
    scope: [ROLE_SCOPES.global, ROLE_SCOPES.custom],
    permissions: [
      BACKEND_PERMISSIONS.POLICIES_FULL,
      BACKEND_PERMISSIONS.POLICIES_VIEW,
      BACKEND_PERMISSIONS.GOVERNANCE_FULL,
      BACKEND_PERMISSIONS.GOVERNANCE_READ_ONLY
    ]
  },
  [ACTIONS.POLICY_WORKFLOWS_VIEW]: {
    scope: [ROLE_SCOPES.global, ROLE_SCOPES.custom],
    permissions: [BACKEND_PERMISSIONS.POLICIES_FULL, BACKEND_PERMISSIONS.POLICIES_VIEW]
  },
  [ACTIONS.UAR_WORKFLOWS_VIEW]: {
    scope: [ROLE_SCOPES.global, ROLE_SCOPES.custom],
    permissions: [BACKEND_PERMISSIONS.GOVERNANCE_FULL, BACKEND_PERMISSIONS.GOVERNANCE_READ_ONLY]
  },
  [ACTIONS.NOTIFICATIONS_VIEW]: {
    scope: [ROLE_SCOPES.custom, ROLE_SCOPES.alerts, ROLE_SCOPES.datasource]
  },
  [ACTIONS.POLICIES_VIEW]: {
    scope: [ROLE_SCOPES.datasource, ROLE_SCOPES.custom],
    permissions: [BACKEND_PERMISSIONS.POLICIES_FULL, BACKEND_PERMISSIONS.POLICIES_VIEW]
  },
  [ACTIONS.MY_ALERTS_VIEW]: {
    scope: [ROLE_SCOPES.datasource, ROLE_SCOPES.alerts, ROLE_SCOPES.custom],
    permissions: [
      BACKEND_PERMISSIONS.ALERTS_LIMITED,
      BACKEND_PERMISSIONS.ALERTS_FULL,
      BACKEND_PERMISSIONS.ALERTS_VIEW
    ]
  },
  [ACTIONS.ALERTS_ALL_VIEW]: {
    scope: [ROLE_SCOPES.global, ROLE_SCOPES.custom],
    permissions: [BACKEND_PERMISSIONS.ALERTS_FULL, BACKEND_PERMISSIONS.ALERTS_VIEW]
  },
  [ACTIONS.ALERTS_AUDIT_LOGS_VIEW]: {
    scope: [ROLE_SCOPES.datasource, ROLE_SCOPES.alerts, ROLE_SCOPES.custom],
    permissions: [
      BACKEND_PERMISSIONS.ALERTS_AUDIT_LOGS_FULL,
      BACKEND_PERMISSIONS.ALERTS_AUDIT_LOGS_READ_ONLY,
      BACKEND_PERMISSIONS.ALERTS_AUDIT_LOGS_LIMITED
    ]
  },
  [ACTIONS.POLICY_PARAMETERS_VIEW]: {
    scope: [ROLE_SCOPES.global, ROLE_SCOPES.custom],
    permissions: [BACKEND_PERMISSIONS.POLICIES_FULL, BACKEND_PERMISSIONS.POLICIES_VIEW]
  },
  [ACTIONS.PLAYBOOK_SETTINGS_VIEW]: {
    permissions: [BACKEND_PERMISSIONS.ALERTS_FULL]
  },
  // object viewer
  [ACTIONS.OBJECT_VIEWER_FILE_VIEW]: {
    scope: [ROLE_SCOPES.datasource, ROLE_SCOPES.alerts, ROLE_SCOPES.custom],
    permissions: [BACKEND_PERMISSIONS.OBJECT_VIEWER_FULL, BACKEND_PERMISSIONS.OBJECT_VIEWER_VIEW]
  },
  [ACTIONS.OBJECT_VIEWER_ATTRIBUTES_VIEW]: {
    scope: [ROLE_SCOPES.datasource, ROLE_SCOPES.alerts, ROLE_SCOPES.custom],
    permissions: [BACKEND_PERMISSIONS.OBJECT_VIEWER_FULL, BACKEND_PERMISSIONS.OBJECT_VIEWER_VIEW]
  },

  // settings
  [ACTIONS.ABOUT_VIEW]: { scope: [ROLE_SCOPES.global, ROLE_SCOPES.custom] },
  [ACTIONS.AUTH_PROVIDES_VIEW]: {
    scope: [ROLE_SCOPES.global, ROLE_SCOPES.custom],
    permissions: [
      BACKEND_PERMISSIONS.AUTH_PROVIDER_FULL,
      BACKEND_PERMISSIONS.AUTH_PROVIDER_READ_ONLY
    ]
  },
  [ACTIONS.SMTP_CONFIG_VIEW]: {
    scope: [ROLE_SCOPES.global, ROLE_SCOPES.custom],
    permissions: [
      BACKEND_PERMISSIONS.SMTP_SETTINGS_FULL,
      BACKEND_PERMISSIONS.SMTP_SETTINGS_READ_ONLY
    ]
  },
  [ACTIONS.USER_MANAGEMENT_VIEW]: {
    scope: [ROLE_SCOPES.global, ROLE_SCOPES.custom],
    permissions: [
      BACKEND_PERMISSIONS.USER_MANAGEMENT_FULL,
      BACKEND_PERMISSIONS.USER_MANAGEMENT_READ_ONLY
    ]
  },
  [ACTIONS.ROLE_MANAGEMENT_VIEW]: {
    scope: [ROLE_SCOPES.global, ROLE_SCOPES.custom],
    permissions: [
      BACKEND_PERMISSIONS.ROLE_MANAGEMENT_FULL,
      BACKEND_PERMISSIONS.ROLE_MANAGEMENT_READ_ONLY
    ]
  },
  [ACTIONS.REPORT_CONFIG_VIEW]: {
    scope: [ROLE_SCOPES.global, ROLE_SCOPES.custom],
    permissions: [
      BACKEND_PERMISSIONS.REPORT_SETTINGS_FULL,
      BACKEND_PERMISSIONS.REPORT_SETTINGS_READ_ONLY
    ]
  },
  [ACTIONS.RISK_SCORE_CONFIG_VIEW]: {
    scope: [ROLE_SCOPES.global, ROLE_SCOPES.custom],
    permissions: [
      BACKEND_PERMISSIONS.RISK_SCORE_SETTINGS_FULL,
      BACKEND_PERMISSIONS.RISK_SCORE_SETTINGS_READ_ONLY
    ]
  }
}
